import src from "IMAGE";
export default { src, width: 1162, height: 708, blurWidth: 0, blurHeight: 0};
